import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import { APP_PAGES } from '../../../../data/config/constants';
import { uniqueId, showMessage } from '../../../../data/config/utils';
import { IMG_ERROR } from '../../../../data/assets/img';
import { pageChanged } from '../../../../data/redux/page_details/actions';
import * as usersActions from '../../../../data/redux/users_details/actions';

import PageHeaderLoader from '../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../components/loaders/cardrowtable';
import ShowMessage from '../../../../components/showmessage';
import CustomPagination from '../../../../components/custompagination';
import CardContainer from '../../components/cardcontainer';

class Users extends PureComponent {
  componentWillMount() {
    const { actions, users_details } = this.props;
    actions.pageChanged(APP_PAGES.USERS, APP_PAGES.USERS);
    if (users_details.users.length === 0 || users_details.users_table_columns.length === 0) {
      actions.getUsersListAndColumns(users_details.users_table_filters, this.viewUserProfile);
    }
  }

  viewUserProfile = user => {
    const { history, match } = this.props;
    if (user && user.key) {
      const path = `${match.path}/${user.key}&type=${user.idType}`;
      history.push(path);
    } else {
      showMessage('error', 'user data is not valid.');
    }
  };

  handleUserSearch = searchKey => {
    const { actions, users_details } = this.props;
    const payload = {
      ...users_details.users_table_filters,
      searchKey,
    };
    actions.getUsersList(payload, () => {
      actions.updateUsersState(1, "users_table_pagination.current");
      actions.updateUsersState(searchKey, "users_table_filters.searchKey");
    });
  };

  onChangeUsersTablePagination = current => {
    if (current) {
      const { actions, users_details } = this.props;
      const payload = {
        ...users_details.users_table_filters,
        skip: (current - 1) * users_details.users_table_filters.limit,
      };
      actions.getUsersList(payload, () => actions.updateUsersState(current, "users_table_pagination.current"));
    }
  };

  render() {
    const { screen_width, users_details } = this.props;
    const { users_and_columns_loading, users_and_columns_loaded, users_loading, users_load_error } = this.props.users_details.loaders;
    if (users_and_columns_loading && !users_and_columns_loaded) {
      return (
        <div className="ori-full-parent-height">
          <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
          <div className="ori-pad-10">
            <CardRowTableLoader />
          </div>
        </div>
      );
    } else if (!users_and_columns_loading && users_and_columns_loaded) {
      const mobile = screen_width < 768;
      const custom_header_props = {
        title: "Chatbot Users",
        search_placeholder: "Search users",
        onSearch: this.handleUserSearch,
        show_search: true,
        bottom_bordered: true,
      };
      return (
        <div className="ori-lr-pad-10">
          <CardContainer card_container_class="" loader_container_class="ori-opacity-medium ori-bg-default" custom_header_props={custom_header_props} emtpy_condition={users_details.users.length === 0} loading={users_loading} load_error={users_load_error} show_custom_header>
            <div className="ori-t-pad-10">
              <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} pagination={false} columns={users_details.users_table_columns} dataSource={users_details.users} />
              <CustomPagination size="small" current={users_details.users_table_pagination.current} next_disabled={!users_details.users_table_pagination.more_pages} onChange={this.onChangeUsersTablePagination} />
            </div>
          </CardContainer>
        </div>
      );
    } else if (!users_and_columns_loading && !users_and_columns_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load user list. please check your internet connection and reload the page." height={150} width={150} />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    users_details: state.users_details,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, usersActions), dispatch),
  };
}

Users.propTypes = {
  screen_width: PropTypes.number,
  users_details: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Users);


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/users/index.js